import React from 'react'
import { request } from 'meinian-package/src/utils'
import { message } from 'antd'

/**
 * @description: 设置灵感集快速访问的组件
 * @param {number} isQuickAccess: 是否快速访问(1:快速访问，0:访问)
 * @param {string} id: 灵感集id
 * @param {string} name: 灵感集name
 * @param {ReactDOM} children: children
 * @param {function} onChange: change函数
 * @return {*}
 */

export default (props) => {
  const { isQuickAccess, id, name, children, onChange } = props
  const setQuickAccess = async (e) => {
    e.stopPropagation()
    if (isQuickAccess === 0) { // 添加快速访问
      const res = await request.get('/zhikuan/ins/quick-access/save-quick-access', { params: { entityId: id, entityName: name } })
      onChange && onChange(res, { id, isQuickAccess: 1 })
      res && message.success('添加成功')
    } else {
      const res = await request.get('/ins/quick-access/remove-quick-access', { params: { inspirationId: id } })
      onChange && onChange(res, { id, isQuickAccess: 0 })
      message.success('移除成功')
    }
  }
  return (
    <div
      onClick={setQuickAccess}
    >
      {children || '快速访问'}
    </div>
  )
}
